export const SectionsMetadata = {
    kidney: {
        general: {
            title: 'Bubreg općenito, anatomija i fiziologija',
            description: 'Anatomija i fiziologija bubrega, gdje se nalaze bubrezi, funkcija bubrega'
        },
        cancer: {
            title: 'Rak bubrega',
            description: 'Rak bubrega (karcinom ili tumor bubrega), dijagnostika i liječenje raka bubrega. Ultrazvuk bubrega, magnetska rezonanca bubrega, scintigrafija kostiju.'
        },
        inflammation: {
            title: 'Upala bubrega, pijelonefritis',
            description: 'Kronična i akutna upala bubrega, simptomi upale bubrega, pijelonefritis. Bol u bubrezima, učestalo mokrenje, bolno i otežano mokenje, krv u mokraći.'
        },
        stones: {
            title: 'Bubrežni kamenac, nefrolitijaza',
            description: 'Kamenac u bubregu, kamenac u mokraćnim kanalima. Simptomi, dijagnostika i liječenje bubrežnih kamenaca. Liječenje bubrežnog kamenca, PNS, JJ proteza, ESWL.'
        },
        cists: {
            title: 'Ciste bubrega, cistična bolest bubrega',
            description: 'Simtomi, dijagnostika i liječenje cista bubrega, kompjuterizirana tomografija bubrega, bol zbog ciste bubrega. Punkcija i operacija ciste bubrega.'
        },
        transplant: {
            title: 'Transplantacija bubrega',
            description: 'Transplantacija bubrega, donor i primatelj bubrega. Imunosupresija i lijekovi nakon transplantacije bubrega.',
        }
    },
    urethra: {
        general: {
            title: 'Mokraćovod, ureter',
            description: 'Anatomija i funkcija mokraćovoda (uretera).'
        },
        cancer: {
            title: 'Rak mokraćovoda',
            description: 'Simtomi i dijagnostika, urografija, cistoskopija, ureterorenoskopija, retrogradna ureterografija. Liječenje - operacija, zračenje, lijekovi.'
        },
        stones: {
            title: 'Kamenci bubrega i mokraćovoda (uretera)',
            description: 'Kamenci u mokraćnim kanalima, kamenci u mokraćovodu, kamenci u mokraći u bubregu i mokraćovodu. Liječenje - aktivno, ESWL, laser, PCNL, operacije. '
        }
    },
    bladder: {        
        general: {
            title: 'Anatomija i funkcija mokraćnog mjehura',
            description: 'Mokraćni mjehur, anatomija i funkcija mokraćnog sustava, građa mokraćnog mjehura i mokraćnog sustava.'
        },
        cancer: {
            title: 'Rak mokraćnog mjehura',
            description: 'Karcinom mokraćnog mjehura kod žena i muškaraca, simtomi i dijagnoza raka mokraćnog mjehura, krvu u mokraći (hematurija), liječenje raka mokraćnog mjehura.'
        },
        inflammation: {
            title: 'Upala mokraćnog mjehura (Cystitis)',
            description: 'Upala mokraćnog mjehura ili cistitis, simptomi akutnog i rekurentnog cistitisa, dijagnoza i liječenje cistitisa.'
        },
        stones: {
            title: 'Kamenci mokraćnog mjehura',
            description: 'Simptomi kamenca mokraćnog mjehura - krv u mokraći, bolno mokrenje. Cistoskopija, UZV i CT mokraćnog mjehura, kultura urina, urin sediment. Liječenje - ESWL, laser, operacija.'
        },
    },
    prostate: {        
        general: {
            title: 'Anatomija i fiziologija prostate',
            description: 'Građa i funkcija prostate, prostata specifični antigen (PSA).'
        },
        cancer: {
            title: 'Rak prostate, karcinom prostate',
            description: 'Rak i metastaza raka prostate, simptomi i dijagnostika (MR, PET-CT, UZV, biopsija, scintigrafija). Liječenje - operacija, lijekovi, zračenje, praćenje.'
        },
        inflammation: {
            title: 'Upala prostate (prostatitis)',
            description: 'Akutni i kronični prostatitis, sindrom kronične zdjelične boli, simptomi, dijagnostika i liječenje - antibiotici, fitoterapija.'
        },
        enlargement: {
            title: 'Benigno povećanje prostate (benigna hipertrofija prostate)',
            description: 'Simtomi i dijagnostika benignog povećanja prostate (BHP), problemi s mokrenjem, slab mlaz, otežano mokrenje. Liječenje operacijom, lijekovima i kateterom.'
        },
    },
    testis: {        
        general: {
            title: 'Anatomija i fiziologija testisa',
            description: 'Testisi su spolne žlijezde koje proizvode spermije. Oni također proizvode i muški spolni hormon testosteron, koji je važan za normalno funkcioniranje muškarca.'
        },
        cancer: {
            title: 'Rak ili karcinom testisa',
            description: 'Simptomi tumora testisa, krvržica na testisu. Dijagnostika - ultrazvuk, tumorski markeri, AFP, betaHCG. Liječenje operacijom, zračenjem i lijekovima.'
        },
        inflammation: {
            title: 'Upala testisa i epididimisa (Orchiepididymitis)',
            description: 'Akutna i kronična upala testisa. Simptomi i dijagnostika upale testisa - color doppler, kultura sjemena, kultura urina, pregled testisa. Liječenje upale testisa.'
        },
        hydrocele: {
            title: 'Hidrokela/spermatokela',
            description: 'Simptomi hidrokele - oticanje testisa i skrotuma. Dijagnostika i liječenje - otvorena operacija i punkcija hidrokele/spermatokele.'
        },
        varicocele: {
            title: 'Varikokela (Varicocelle)',
            description: 'Simptomi su proširene vene testisa ili skrotuma. Dijagnoza - color doppler i ultrazvuk testisa. Liječenje operacijom po Polomo-Robbu.'
        },
        torsion: {
            title: 'Torzija (uvrtanje) testisa',
            description: 'Hitno stanje gdje dolazi do okretanja testisa. Simptom je nagla bol testisa/mošnje. Liječi se odvrtanjem ili odstranjenjem testisa ako je previše oštećen.'
        },
        infertility: {
            title: 'Muška neplodnost',
            description: 'Muška neplodnost je nemogućnost oplodnje jajne stanice. Dijagnosticira se pregledom - color doppler i ultrazvuk testisa, spermiogram, mikrobiološka analiza sjemena...'
        },
    },
    penis: {
        general: {
            title: 'Anatomija i funkcija penisa',
            description: 'Penis se sastoji od kavernoznih tkiva koja se ispune krvlju kada je penis u erekciji te glavića (glansa) i mokraćne cijevi (uretre) kroz koju mokrimo.'
        },
        cancer: {
            title: 'Rak penisa',
            description: 'Karcinom, odnosno rak penisa je rijetka bolest. Bolest obično počinje kao bezbolno zadebljanje ili otvrdnuće na penisu. Liječi se operacijom i lijekovima.'
        },
        phimosis: {
            title: 'Fimoza',
            description: 'Fimoza je suženje kože glavića (glansa) penisa. Liječi se operacijom - cirkumcizijom tj. uklanjanjem dijela kože koji je sužen.'
        },
        frenulum: {
            title: 'Kratki frenulum (frenulum breve)',
            description: 'Frenulum breve, odnosno kratki frenulum je skraćenje komadića kože na donjem dijelu glavića penisa koje kod erekcije zateže glavić penisa prema dolje.'
        },
        induratio: {
            title: 'Induratio penis plastica (Mb. Peyroni)',
            description: 'Bolesnici koji pate od ovog poremećaja se žale na iskrivljenost penisa, otvrdnuća na penisu te na bolove i probleme s potencijom, odnosno spolnim odnosom.'
        },
        disfunction: {
            title: 'Spolna nemoć (impotencija ili erektilna disfunkcija tj. ED)',
            description: 'Spolna nemoć, odnosno impotencija ili erektilna disfunkcija (ED) je naziv za nedovoljnu ukrućenost penisa za normalan spolni odnos. Liječi se lijekovima, injekcijama ili oepracijom.'
        },
    },
    ureter: {
        general: {
            title: 'Anatomija i fiziologija mokraćne cijevi (uretre)',
            description: 'Mokraćna cijev (uretra) je cijev koja počinje u mokraćnom mjehuru i kod muškaraca završava na vrhu penisa ili iznad rodnice. Kroz nju mokraća iz mokraćnog mjehura izlazi van.'
        },
        cancer: {
            title: 'Karcinom (rak) mokraćne cijevi',
            description: 'Uglavnom se javlja kod muškaraca u starijoj životnoj dobi. Simptomi su otežano i bolno mokrenje, uzak mlaz urina, krv u urinu i zadebljanja na penisu.'
        },
        inflammation: {
            title: 'Upala mokraćne cijevi (uretre)',
            description: 'Uretritis je upala mokraćne cijevi (uretre). Upala može biti akutna ili kronična. Bolesnici najčešće imaju akutnu upalu mokraćne cijevi (akutni uretritis).'
        },
        constriction: {
            title: 'Suženje (striktura) mokraćne cijevi',
            description: 'Seženje mokraćne cijevi može uzrokovati otežano, bolno i isprekidano mokrenje. Dijagnosticira se uroflowom, analizom mokraće, uretrocistoskopijom i uretrografijom.'
        }
    }
}
